import Vue from 'vue'
import VueRouter from 'vue-router'

import Layout from '@/layout'

Vue.use(VueRouter)

export const constantRouter = [{
    path: '/login',
    component: () => import('@/views/login/index'),
    // hidden: true
  },
  {
    path: '/404',
    component: () => import('@/views/404/index'),
    // hidden: true
  },
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    meta: {
      title: '管理系统'
    },
    hidden: true,
    children: [{
      path: 'dashboard',
      name: 'dashboard',
      component: () => import('@/views/Home/index'),
      meta: {
        title: '首页',
        breads: ['首页']
      },
      hidden: false
    }]
  },

  {
    path: '/report',
    component: Layout,
    redirect: '/report/list',
    meta: {
      title: '数据报表',
      back: true // 点击面包屑返回上一级
    },
    hidden: true,
    children: [{
      path: 'list',
      name: 'list',
      component: () => import('@/views/report/index'),
      meta: {
        title: '项目报表',
        icon: 'xiangmu_1',
        breads: ['项目管理', '项目列表', '项目报表']
      },
      hidden: true
    }, {
      path: 'appList',
      name: 'appList',
      component: () => import('@/views/reportApp/index'),
      meta: {
        title: 'App报表',
        icon: 'xiangmu_1',
        breads: ['项目管理', '项目列表', 'App管理', 'App报表']
      },
      hidden: true
    }]
  },
  // {
  //   path: '/application',
  //   component: Layout,
  //   redirect: '/application/index',
  //   alwaysShow: true,
  //   meta: {
  //     title: '应用',
  //     icon: 'kongzhi'
  //   },
  //   children: [{
  //     path: 'index',
  //     name: 'index',
  //     component: () => import('@/views/application/index'),
  //     meta: {
  //       title: '列表',
  //       icon: 'liebiao',
  //       breads: ['应用列表']
  //     },
  //     hidden: false
  //   }]
  // },
  {
    path: '/managedata',
    component: Layout,
    redirect: '/managedata/index',
    alwaysShow: true,
    meta: {
      title: '报表',
      icon: 'shuju'
    },
    children: [{
        path: 'index',
        name: 'index',
        component: () => import('@/views/application/index'),
        meta: {
          title: '设备留存',
          icon: 'liucun',
          breads: ['应用列表'],
          type: 1
        },
        hidden: false
      },
      {
        path: 'index2',
        name: 'index2',
        component: () => import('@/views/application/index'),
        meta: {
          title: '收入数据',
          icon: 'shouru',
          breads: ['应用列表'],
          type: 2
        },
        hidden: false
      },
      {
        path: 'index3',
        name: 'index3',
        component: () => import('@/views/application/index'),
        meta: {
          title: '事件留存',
          icon: 'liucun',
          breads: ['应用列表'],
          type: 3
        },
        hidden: false
      }
    ]
  },
  {
    path: '/experience',
    component: Layout,
    redirect: '/experience/speed',
    alwaysShow: true,
    meta: {
      title: '体验数据',
      icon: 'shuju'
    },
    children: [{
      path: 'speed',
      name: 'speed',
      component: () => import('@/views/chartSpeed/index'),
      meta: {
        title: '测速分布',
        icon: 'sudu',
        breads: ['测速分布'],
        type: 3
      },
      hidden: false
    }, {
      path: 'experience',
      name: 'experience',
      component: () => import('@/views/chartExperience/index'),
      meta: {
        title: '体验时长',
        icon: 'shijian',
        breads: ['体验时长'],
        type: 3
      },
      hidden: false
    }]
  },
  {
    path: '/incomedata',
    component: Layout,
    redirect: '/incomedata/index',
    alwaysShow: true,
    hidden: true,
    meta: {
      title: '收入数据',
      icon: 'shuju'
    },
    children: [{
      path: 'index',
      name: 'index',
      component: () => import('@/views/Income/index'),
      meta: {
        title: '收入数据',
        icon: 'liebiao',
        breads: ['收入数据']
      },
      hidden: false
    }]
  },
  {
    path: '/projectManager',
    component: Layout,
    redirect: '/projectManager/index',
    alwaysShow: false,
    hidden: true,
    meta: {
      title: '数据',
      icon: 'kongzhi'
    },
    children: [{
      path: 'index',
      name: 'index',
      component: () => import('@/views/Home/index'),
      meta: {
        title: '首页',
        icon: 'liebiao',
        breads: ['首页']
      },
      hidden: true
    }, {
      path: 'list',
      name: 'list',
      component: () => import('@/views/projectManager/index'),
      meta: {
        title: '项目列表',
        icon: 'liebiao',
        breads: ['项目管理', '项目列表']
      },
      hidden: true
    }, {
      path: 'huoke',
      name: 'huoke',
      hidden: false,
      component: () => import('@/views/TotalReport/index'),
      meta: {
        title: '新增',
        icon: 'new_person',
        breads: ['控制面板', '新增']
      }
    }, {
      path: 'add',
      name: 'add',
      hidden: false,
      component: () => import('@/views/TotalReport3/index'),
      meta: {
        title: '日活',
        icon: 'rihuo',
        breads: ['控制面板', '日活']
      }
    }, {
      path: 'liucun',
      name: 'liucun',
      hidden: false,
      component: () => import('@/views/TotalReport2/index'),
      meta: {
        title: '留存',
        icon: 'liucun',
        breads: ['控制面板', '留存']
      }
    }, {
      path: 'report',
      name: 'report',
      hidden: false,
      component: () => import('@/views/report/index'),
      meta: {
        title: '报表',
        icon: 'report',
        breads: ['控制面板', '报表']
      }
    }, {
      path: 'appManager',
      name: 'appManager',
      hidden: true,
      component: () => import('@/views/appManager/index'),
      meta: {
        title: 'app管理',
        breads: ['项目管理', '项目列表', 'App管理']
      }
    }, {
      path: 'task',
      name: 'task',
      hidden: true,
      component: () => import('@/views/Task/index'),
      meta: {
        title: '调度任务',
        breads: ['项目管理', '项目列表', 'App管理', '调度任务']
      }
    }, {
      path: 'plan',
      name: 'plan',
      hidden: true,
      component: () => import('@/views/Plan/index'),
      meta: {
        title: '执行计划',
        breads: ['项目管理', '调度任务', '执行计划']
      }
    }, {
      path: 'history',
      name: 'history',
      hidden: true,
      component: () => import('@/views/History/index'),
      meta: {
        title: '执行历史',
        breads: ['项目管理', '项目列表', 'App管理', '执行历史']
      }
    }, {
      path: 'input',
      name: 'input',
      hidden: true,
      component: () => import('@/views/Input/index'),
      meta: {
        title: '收入数据',
        breads: ['项目管理', '项目列表', 'App管理', '收入数据']
      }
    }, {
      path: 'output',
      name: 'output',
      hidden: true,
      component: () => import('@/views/Output/index'),
      meta: {
        title: '支出数据',
        breads: ['项目管理', '项目列表', 'App管理', '成本数据']
      }
    }, {
      path: 'new',
      name: 'new',
      hidden: true,
      component: () => import('@/views/TotalReport/index'),
      meta: {
        title: '新增和日活',
        breads: ['项目管理', '项目列表', 'App管理', '新增和日活']
      }
    }, {
      path: 'new2',
      name: 'new2',
      hidden: true,
      component: () => import('@/views/TotalReport2/index'),
      meta: {
        title: '留存',
        breads: ['项目管理', '项目列表', 'App管理', '留存']
      }
    }]
  },
  {
    path: '/set',
    component: Layout,
    redirect: '/set/execution',
    meta: {
      title: '其他来源数据',
      icon: 'shuju'
    },
    children: [{
      path: 'execution',
      name: 'list',
      hidden: true,
      component: () => import('@/views/ExecutionHost/index'),
      meta: {
        title: '执行主机',
        icon: 'jk',
        breads: ['系统设置', '执行主机']
      }
    }, {
      path: 'proxy',
      name: 'proxy',
      hidden: true,
      component: () => import('@/views/ProxyHost/index'),
      meta: {
        title: '代理主机',
        icon: 'jk',
        breads: ['系统设置', '代理主机']
      }
    }, {
      path: 'app-input',
      name: 'app-input',
      hidden: false,
      component: () => import('@/views/Input/index'),
      meta: {
        title: '收入数据',
        icon: 'shouru',
        breads: ['系统设置', '收入数据']
      }
    }, {
      path: 'app-out',
      name: 'app-out',
      hidden: false,
      component: () => import('@/views/Output/index'),
      meta: {
        title: '成本数据',
        icon: 'zhichu',
        breads: ['系统设置', '成本数据']
      }
    }, {
      path: 'app-task',
      name: 'app-task',
      hidden: true,
      component: () => import('@/views/Task/index'),
      meta: {
        title: '调度任务',
        icon: 'renwu',
        breads: ['系统设置', '调度任务']
      }
    }, {
      path: 'app-history',
      name: 'app-history',
      hidden: true,
      component: () => import('@/views/History/index'),
      meta: {
        title: '历史',
        icon: 'lishi',
        breads: ['系统设置', '历史']
      }
    }, {
      path: 'app-detail',
      name: 'app-detail',
      hidden: true,
      component: () => import('@/views/appDetail/index'),
      meta: {
        title: 'App管理',
        icon: 'guanli',
        breads: ['']
      }
    }]
  },
  {
    path: '*',
    redirect: '/404',
    hidden: true
  }
]

const createRouter = () => new VueRouter({
  routes: constantRouter,
  // 滚动到顶部
  scrollBehavior: () => ({
    y: 0
  })
})
const router = createRouter()
// 重置router
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher
}

export default router